import {moderateScale} from "../tools/Scaling";
import * as Colors from "../tools/Colors";

export default {
    container: {
        flex: 1,
        backgroundColor:Colors.white
    },
    navItemStyle: {
        padding: 10
    },
    navSectionStyle: {
        backgroundColor: 'lightgrey'
    },
    sectionHeadingStyle: {
        paddingVertical: 10,
        paddingHorizontal: 5
    },
    footerContainer: {
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'center',
        height:moderateScale (48),
        backgroundColor: 'lightgrey'
    },
    headerText: {
        color: '#fff8f8',
    },
    screenContainer: {
        paddingTop: 20
    },
    screenStyle: {
        height: 30,
        marginTop: 2,
        flexDirection: 'row',
        alignItems: 'center'
    },
    screenTextStyle:{
        fontSize: 20,
        marginLeft: 20
    },
    headerContainer: {
        height: 150,
    },
};
